module.exports = __webpack_public_path__ + "img/brand.fcc66d07.png";